import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { colors } from '../theme';

export default function LoginPage() {
  const { login }  = useAuth();
  const navigate   = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!username || !password) { setError('Both fields are required.'); return; }
    setLoading(true);
    try {
      await login({ username, password, role: 'bmo' });
      navigate('/');
    } catch (err) {
      setError(err?.message || 'Invalid credentials. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight:'100vh', background: colors.primary[800], display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'Segoe UI', Roboto, sans-serif" }}>
      <div style={{ width:'100%', maxWidth:420, padding:'0 16px' }}>

        {/* Logo / heading */}
        <div style={{ textAlign:'center', marginBottom:32 }}>
          <div style={{ fontSize:56, marginBottom:12 }}>🏥</div>
          <h1 style={{ color: colors.white, fontSize:28, fontWeight:800, margin:'0 0 4px' }}>Kayakalp</h1>
          <p style={{ color: colors.primary[200], fontSize:15, margin:0 }}>BMO District Dashboard · NHM India</p>
        </div>

        {/* Card */}
        <div style={{ background: colors.white, borderRadius:16, padding:32, boxShadow:'0 8px 32px rgba(0,0,0,0.2)' }}>
          <h2 style={{ margin:'0 0 24px', fontSize:20, fontWeight:600, color: colors.text.primary }}>Block Medical Officer Login</h2>

          {error && (
            <div style={{ background: colors.error[50], border:`1px solid ${colors.error[200]}`, color: colors.error[700], borderRadius:8, padding:'10px 14px', marginBottom:16, fontSize:14 }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom:16 }}>
              <label style={{ display:'block', fontSize:13, fontWeight:600, color: colors.text.primary, marginBottom:6 }}>Username</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="BMO username"
                autoComplete="username"
                style={{ width:'100%', padding:'10px 14px', border:`1px solid ${colors.neutral[300]}`, borderRadius:8, fontSize:15, color: colors.text.primary, outline:'none', boxSizing:'border-box' }}
              />
            </div>

            <div style={{ marginBottom:24 }}>
              <label style={{ display:'block', fontSize:13, fontWeight:600, color: colors.text.primary, marginBottom:6 }}>Password</label>
              <div style={{ position:'relative' }}>
                <input
                  type={showPass ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                  autoComplete="current-password"
                  style={{ width:'100%', padding:'10px 44px 10px 14px', border:`1px solid ${colors.neutral[300]}`, borderRadius:8, fontSize:15, color: colors.text.primary, outline:'none', boxSizing:'border-box' }}
                />
                <button
                  type="button"
                  onClick={() => setShowPass(!showPass)}
                  style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', fontSize:18, color: colors.neutral[500] }}
                >
                  {showPass ? '🙈' : '👁'}
                </button>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{ width:'100%', padding:'12px', background: loading ? colors.neutral[400] : colors.primary[700], color: colors.white, border:'none', borderRadius:8, fontSize:16, fontWeight:600, cursor: loading ? 'not-allowed' : 'pointer', transition:'background 0.2s' }}
            >
              {loading ? 'Signing in…' : 'Sign In'}
            </button>
          </form>

          <p style={{ margin:'20px 0 0', fontSize:12, color: colors.text.secondary, textAlign:'center' }}>
            Access limited to authorised Block Medical Officers.<br />Contact NHM district office for credential issues.
          </p>
        </div>

        <p style={{ color: colors.primary[300], textAlign:'center', fontSize:12, marginTop:20 }}>
          NHM Madhya Pradesh · Kayakalp Compliance System
        </p>
      </div>
    </div>
  );
}
